import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import styled from '@xstyled/styled-components';
import { Tooltip } from 'antd';
import { getSize } from '../../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledTitle = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: normal;\n"])));
var StyledCardTitle = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 600;\n"])), getSize('typo15'));
export var CardTitle = function CardTitle(_ref) {
  var children = _ref.children,
      marginBottom = _ref.marginBottom;
  return /*#__PURE__*/_jsx(Tooltip, {
    title: children,
    placement: "topLeft",
    children: /*#__PURE__*/_jsx(StyledTitle, {
      children: /*#__PURE__*/_jsx(StyledCardTitle, {
        children: children
      })
    })
  });
};